module.exports = __webpack_public_path__ + "with-mitel-logo-high-resolution.c83fbbafb0e8597d1a03.gif";